module.exports = __webpack_public_path__ + "static/img/logo-white.2e38fc4.png";


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/assets/logo-white.png
// module id = +FBO
// module chunks = 0